export const ARCHIVED_CONDITION_NAME_SUFFIX = ' (archived)';
export const PENDING_ARCHIVE_CONDITION_NAME_SUFFIX = ' (to be archived)';

interface GetConditionNameSuffixOptions {
  isArchived: boolean;
  isPendingArchive: boolean;
}

/**
 * Returns the leading-space name suffix for an inert condition. Archived wins over pending so a
 * persisted archive never reads as an unsaved preview.
 */
export function getConditionNameSuffix({
  isArchived,
  isPendingArchive,
}: GetConditionNameSuffixOptions): string {
  if (isArchived) {
    return ARCHIVED_CONDITION_NAME_SUFFIX;
  }
  return isPendingArchive ? PENDING_ARCHIVE_CONDITION_NAME_SUFFIX : '';
}
